const LIGHT_COLORS = ['lighter', 'lightest'];

export default function isColorLight(color) {
  return LIGHT_COLORS.some(light => color.endsWith(light));
}
